module.exports = __webpack_public_path__ + "static/img/product_1_1.07c7059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_1_1.png
// module id = lXfe
// module chunks = 34